module.exports = __webpack_public_path__ + "img/icon-generic-day.3bc29078.svg";